(function () {
  function init(root) {
    var data = JSON.parse(root.querySelector('[data-bb-data]').textContent);
    var robes = data.robes.filter(function (r) { return r.variants.some(function (v) { return v.available; }); });
    if (!robes.length) return;
    var order = ['Oatmeal', 'Dust Pink', 'Baby Blue', 'Pastel Matcha', 'Light Coral', 'Electric Yellow', 'Cloud White'];
    var cycle = order.map(function (t) { return robes.findIndex(function (r) { return r.title === t; }); }).filter(function (i) { return i > -1; });
    if (!cycle.length) cycle = robes.map(function (_, i) { return i; });
    var pre = (new URLSearchParams(window.location.search).get('color') || '').trim().toLowerCase();
    if (pre) {
      var pi = robes.findIndex(function (r) { return r.title.toLowerCase() === pre; });
      if (pi > -1) cycle = [pi].concat(cycle.filter(function (i) { return i !== pi; }));
    }
    var rows = [], MAX = 12;
    var $ = function (s) { return root.querySelector(s); };
    var money = function (c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); };
    var short = function (s) { return s.replace(/Small\s*-\s*Medium/i, 'S–M').replace(/Large\s*-\s*X-Large/i, 'L–XL'); };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var plural = function (n) { return n + ' robe' + (n === 1 ? '' : 's'); };

    function newRow(i) { return { color: cycle[i % cycle.length], size: null, name: '' }; }
    function setCount(n) {
      n = Math.max(1, Math.min(MAX, n));
      while (rows.length < n) rows.push(newRow(rows.length));
      rows.length = n;
      render();
    }
    function variantFor(r) { var robe = robes[r.color]; return (robe && r.size !== null) ? robe.variants[r.size] : null; }

    function renderRows() {
      $('[data-rows]').innerHTML = rows.map(function (r, i) {
        var robe = robes[r.color];
        var sw = robes.map(function (rb, ci) {
          return '<button type="button" class="rg-bb__sw" data-i="' + i + '" data-color="' + ci + '" style="background:' + esc(rb.hex) + '" aria-pressed="' + (ci === r.color) + '" aria-label="' + esc(rb.title) + '" title="' + esc(rb.title) + '"></button>';
        }).join('');
        var sizes = robe.variants.map(function (v, si) {
          return '<button type="button" class="rg-bb__size" data-i="' + i + '" data-size="' + si + '" aria-pressed="' + (si === r.size) + '"' + (v.available ? '' : ' disabled') + '>' + esc(short(v.size)) + '</button>';
        }).join('');
        return '<li class="rg-bb__row" data-row="' + i + '">' +
          '<img class="rg-bb__thumb" src="' + esc(robe.img) + '" alt="' + esc(robe.title) + ' muslin robe" loading="lazy">' +
          '<div><div class="rg-bb__row-top"><strong>Robe ' + (i + 1) + '</strong>' +
          '<input class="rg-bb__name" data-i="' + i + '" maxlength="40" placeholder="Who is it for? (optional)" value="' + esc(r.name) + '">' +
          (rows.length > 1 ? '<button type="button" class="rg-bb__remove" data-remove="' + i + '" aria-label="Remove robe ' + (i + 1) + '">×</button>' : '') + '</div>' +
          '<p class="rg-bb__label">Color: <b>' + esc(robe.title) + '</b></p>' +
          '<div class="rg-bb__swatches">' + sw + '</div>' +
          '<p class="rg-bb__label rg-bb__label--size">Size: <b>' + (r.size === null ? 'choose one' : esc(short(robe.variants[r.size].size))) + '</b></p>' +
          '<div class="rg-bb__sizes">' + sizes + '</div></div></li>';
      }).join('');
    }

    function renderSummary() {
      var sub = 0, ready = 0;
      $('[data-lines]').innerHTML = rows.map(function (r) {
        var robe = robes[r.color], v = variantFor(r);
        var price = v ? v.price : robe.variants[0].price; sub += price; if (v) ready++;
        return '<li><i style="background:' + esc(robe.hex) + '"></i>' + (r.name.trim() ? esc(r.name.trim()) + ' · ' : '') + esc(robe.title) + ' · ' + (v ? esc(short(v.size)) : '<span style="color:#a3361d">size?</span>') + '<em>' + money(price) + '</em></li>';
      }).join('');
      var disc = Math.round(sub * data.discount / 100), after = sub - disc, free = after >= data.freeShip;
      $('[data-subtotal]').textContent = money(sub);
      $('[data-discount]').textContent = data.discount ? '−' + money(disc) : '';
      $('[data-ship]').textContent = free ? 'Free' : 'At checkout';
      $('[data-total]').textContent = money(after);
      $('[data-ship-note]').textContent = free ? 'Your set ships free in the US' : 'Add ' + money(data.freeShip - after) + ' more for free US shipping';
      var missing = rows.length - ready;
      root.querySelectorAll('[data-cta]').forEach(function (b) {
        b.disabled = false;
        b.textContent = missing ? 'Choose ' + (missing === 1 ? 'a size' : missing + ' sizes') + ' to continue' : 'Add ' + plural(rows.length) + ' to bag · ' + money(after);
      });
      $('[data-bar-total]').textContent = money(after);
      $('[data-bar-count]').textContent = plural(rows.length) + (data.discount ? ' · ' + data.discount + '% off' : '');
      root.querySelectorAll('[data-count]').forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.count === rows.length)); });
      $('[data-add]').style.display = rows.length >= MAX ? 'none' : '';
    }
    function render() { renderRows(); renderSummary(); }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      if (t.dataset.count) return setCount(+t.dataset.count);
      if (t.hasAttribute('data-add')) return setCount(rows.length + 1);
      if (t.dataset.remove !== undefined) { rows.splice(+t.dataset.remove, 1); return render(); }
      if (t.dataset.color !== undefined) {
        var r = rows[+t.dataset.i]; r.color = +t.dataset.color;
        if (r.size !== null && !robes[r.color].variants[r.size].available) r.size = null;
        return render();
      }
      if (t.dataset.size !== undefined) { rows[+t.dataset.i].size = +t.dataset.size; return render(); }
      if (t.hasAttribute('data-cta')) return submit();
    });
    root.addEventListener('input', function (e) {
      if (e.target.classList.contains('rg-bb__name')) { rows[+e.target.dataset.i].name = e.target.value; renderSummary(); }
    });

    function submit() {
      var err = $('[data-error]'); err.textContent = '';
      var missing = rows.map(function (r, i) { return variantFor(r) ? -1 : i; }).filter(function (i) { return i > -1; });
      if (missing.length) {
        root.querySelectorAll('.rg-bb__row').forEach(function (li) { li.classList.toggle('is-missing', missing.indexOf(+li.dataset.row) > -1); });
        var first = root.querySelector('.rg-bb__row.is-missing');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        err.textContent = 'Please choose a size for ' + missing.map(function (i) { return 'Robe ' + (i + 1); }).join(', ') + '.';
        return;
      }
      var items = rows.map(function (r) {
        var props = { '_bundle': 'Bridal party set' };
        if (r.name.trim()) props['For'] = r.name.trim();
        return { id: variantFor(r).id, quantity: 1, properties: props };
      });
      root.querySelectorAll('[data-cta]').forEach(function (b) { b.disabled = true; b.textContent = 'Adding to bag…'; });
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Something went wrong.'); return j; }); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (e) { err.textContent = e.message + ' Please try again.'; renderSummary(); });
    }

    setCount(+root.dataset.defaultCount || 3);
  }
  function boot() { document.querySelectorAll('[data-rg-bb]').forEach(function (el) { if (!el.dataset.ready) { el.dataset.ready = '1'; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
